/**
 * @file index.tsx
 *
 * @fileoverview Renders landing page large organization profile teaser row.
 */
import OrganizationTeaserLarge from '~/jobiqo/components/Organization/Teaser/Large';
import { OrganizationProfileParagraph } from '~/jobiqo/types/types';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import Box from '~/vcl/atoms/07-box';

interface OrganizationProfileRowProps {
  row: OrganizationProfileParagraph;
  /**
   * The size for the container.
   */
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export function OrganizationProfileRow({
  row,
  maxContainerSize,
}: OrganizationProfileRowProps) {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      paddingTop={row.spacing ?? 12}
      paddingBottom={row.spacing ?? 12}
      paddingLeft={[6, 12]}
      paddingRight={[6, 12]}
      marginTop={0}
      backgroundColorOverride={
        row.background ? `var(--color-${row.background})` : `var(--color-white)`
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <OrganizationTeaserLarge {...row} />
      </Main>
    </Box>
  );
}
export default OrganizationProfileRow;
